// src/api/axiosInstance.js
import axios from 'axios';
import { createBrowserHistory } from 'history';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
});

// 建立 history 物件（不在 React component 裡不能用 useNavigate）
const history = createBrowserHistory();

// 設定 response interceptor
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      alert("登入已過期，請重新登入");

      // 清除 localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      // 導向登入頁（需搭配 React Router）
      history.push("/login");
      window.location.reload(); // 強制刷新以套用跳轉
    }

    return Promise.reject(error);
  }
);

export default instance;
